
const DisplayField = ({object, column}) => {
    return <>{object[column.name]}</>
}

export default DisplayField;